import React, { useEffect, useState, Suspense, lazy, useMemo, useCallback, Profiler } from 'react'
import { IntlProvider } from 'react-intl'
import { getTranslations } from './translations/index';
import { flattenMessages } from './helper/common';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Cookies from "js-cookie";
import Header from './components/Header';
import ErrorBoundary from './components/common/ErrorBoundary';
import NotificationContainer from './components/common/NotificationSystem';
import LoadingSpinner from './components/common/LoadingSpinner';

// Import responsive styles
import './styles/responsive.css';
import './styles/GlobalStyles.css';

// Lazy load route components
const NumerologyCalculator = lazy(() => import('./components/NumerologyCalculatorNew'));
const EnhancedCompatibility = lazy(() => import('./components/EnhancedCompatibility'));

export default function App() {

  const [messages, setMessages] = useState({});
  const language = Cookies.get("tmpl_lang") || "en";

  const [lang, setLang] = useState(language);

  // Memoize the translation loading to prevent unnecessary re-renders
  const fetchTranslations = useCallback(async () => {
    const asyncMessages = await getTranslations(lang);
    setMessages(asyncMessages);
  }, [lang]);

  useEffect(() => {
    fetchTranslations();
  }, [fetchTranslations]);

  // Memoize flattened translations to prevent recalculation
  const translations = useMemo(() => flattenMessages(messages), [messages]);

  // Performance profiler callback (only in development)
  const onRenderCallback = useCallback((id, phase, actualDuration) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(`Component ${id} took ${actualDuration}ms to ${phase}`);
    }
  }, []);

  return (
    <Profiler id="App" onRender={onRenderCallback}>
      <ErrorBoundary>
        <IntlProvider locale={language} messages={translations}>
          <Router>
            <div className="app-container fade-in">
              <Header lang={lang} setLang={setLang} />
              <main className="main-content">
                <Suspense fallback={<LoadingSpinner text="Loading..." />}>
                  <Routes>
                    <Route exact path="/" element={<NumerologyCalculator lang={lang} />} />
                    <Route exact path="/compatibility" element={<EnhancedCompatibility lang={lang} />} />
                  </Routes>
                </Suspense>
              </main>
            </div>
          </Router>
        </IntlProvider>
        <NotificationContainer />
      </ErrorBoundary>
    </Profiler>
  );
}
